module.exports = __webpack_public_path__ + "media/question7_au.9e2ed658.mp3";